import PropTypes from 'prop-types'
import { SingleStarRating } from 'components/common/rating/types'

export default PropTypes.shape({
  overall_rating: PropTypes.number.isRequired,
  price_rating: PropTypes.number.isRequired,
  quality_rating: PropTypes.number.isRequired,
  service_rating: PropTypes.number.isRequired,
  timeliness_rating: PropTypes.number.isRequired
})

export interface StarRatings {
  overall_rating: SingleStarRating
  price_rating: SingleStarRating
  quality_rating: SingleStarRating
  service_rating: SingleStarRating
  timeliness_rating: SingleStarRating
}
